import React from "react";
import { useTranslation } from "react-i18next";
import BaseTooltip from "@reusables/BaseTooltip";

interface StockQuantityProperties {
    inStock: number | null;
    minInventoryQuantity: number | null | undefined;
}

export const isBelowMinimum = (
    inStock: number | null,
    minInventoryQuantity: number | null | undefined
) => typeof minInventoryQuantity === "number" && (inStock ?? 0) < minInventoryQuantity;

/**
 * "Quantity in stock" cell of the Locations tab tables.
 * The quantity is highlighted in red with a tooltip, when it is below the location's min. inventory quantity.
 */
export default function StockQuantity(props: StockQuantityProperties) {
    const { t } = useTranslation("", { keyPrefix: "products.viewEditProduct.tabs.locations" });

    const quantity = props.inStock ?? "-";

    if (!isBelowMinimum(props.inStock, props.minInventoryQuantity)) return <>{quantity}</>;

    return (
        <BaseTooltip
            title={t("table.belowMinimumTooltip", { min: props.minInventoryQuantity }) as string}
            placement="top"
        >
            <span className="font-semibold text-[#E25C5C]">{quantity}</span>
        </BaseTooltip>
    );
}
